import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from '../../../../@casino/useRouter';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { setGetListLanguage } from '../store/thunk/setGetListLanguage';
import { useFieldArray, useForm } from 'react-hook-form';
import { setPostDictionary } from '../store/thunk/setPostDictionary';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%',
    },
    mt0: {
        marginTop: 0
    },
    wrapActiveBonus: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '70%'
    },
}))

const DictionaryCreate = () => {
    const dispatch = useDispatch();
    const router = useRouter();
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(setGetListLanguage())
    }, [])

    const {
        register,
        handleSubmit,
        control
    } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: {
            texts: [],
            code: new Date().getTime()
        },
    })

    const {append, fields} = useFieldArray({
        control,
        name: 'texts'
    })

    const onSubmit = (store) => {
        let isValid = store.texts.filter((item) => !item.text)?.length;
        if (!isValid) {
            dispatch(setPostDictionary(store));
        } else {
            alert('Необходимо заполнить все языки')
        }
    }

    const language = useSelector((state) => state.dictionary.language);

    React.useMemo(() => {
        if (language?.length) {
            for (let i = 0; i < language.length; i++) {
                const item = language[i];
                append({
                    language: item.code,
                    text: ''
                })
            }
        }
    }, [language?.length]);

    return (
        <div style={{ padding: '0 20px' }}>
            <Title
                label="Добавление в справочник"
                labelBtn="Назад"
                button={() => router.history.push('/settings/dictionary/list')}
            />
            <div style={{
                padding: 20,
                background: '#1b2039',
                borderRadius: 8,
            }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <label htmlFor="code" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                        <span className={classes.helper}>Код</span>
                        <input
                            {...register('code')}
                            type="text"
                            id="code"
                            className={classes.text}
                            disabled
                        />
                    </label>
                    <div style={{display: 'flex', columnGap: 20, justifyContent: 'space-between', flexWrap: 'wrap'}}>
                        {
                            fields.map((item, key) => (
                                <label htmlFor="text" className={clsx(classes.wrapLabel, classes.beginBonusLabel, classes.mt0)}>
                                    <span className={classes.helper}>Текст <span style={{color: 'red'}}>{item.language}</span></span>
                                    <textarea
                                        {...register(`texts[${key}].text`)}
                                        type="text"
                                        className={classes.text}
                                        style={{
                                            height: 100
                                        }}
                                    />
                                </label>
                            ))
                        }
                    </div>
                    
                    <div>
                        <button
                            style={{
                                color: '#141b33',
                                cursor: 'pointer',
                                padding: '10px',
                                background: '#ffc324',
                                borderRadius: '4px',
                                border: 'none'
                            }}
                        >
                            Добавить
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default DictionaryCreate;